import {
  AccuracyBlue,
  TimeBlueFilled,
  StarBlue,
  AccuracyGrey,
  TimeGrey,
  StarGrey,
} from '@common/assets';

import { SubjectMetrics, type StudentScheduleSlot } from '../../model';

type SlotItemTheme = {
  textColor: string;
  bgColor: string;
  lockVisible: boolean;
  iconsVisible: boolean;
};

export const getSlotItemTheme = (
  slot: StudentScheduleSlot,
  isMastered: boolean,
  isCurrentlyActive: boolean,
  isComplete: boolean
): SlotItemTheme => {
  const { slotLabel, repeatedClass } = slot;
  const isBreak = slotLabel === 'Lunch' || slotLabel === 'Break';

  let theme: SlotItemTheme = {
    textColor: '#0F1629',
    bgColor: '#F6F7FA',
    iconsVisible: false,
    lockVisible: false,
  };

  // Break
  if (isBreak) {
    return {
      ...theme,
      bgColor: '#B1F6AB',
    };
  }

  if (isCurrentlyActive || repeatedClass) {
    theme = {
      textColor: '#0F1629',
      bgColor: '#B7CCFF',
      iconsVisible: !repeatedClass,
      lockVisible: !!repeatedClass,
    };
  }

  if (isComplete) {
    theme = {
      textColor: isMastered ? '#FFF' : '#0F1629',
      bgColor: isMastered ? '#0414A2' : '#F6F7FA',
      iconsVisible: true,
      lockVisible: false,
    };
  }

  return theme;
};

export const isSubjectMastered = (stats: SubjectMetrics | undefined | null) => {
  if (!stats) {
    return false;
  }

  const { accuracy, mastery } = stats;

  return accuracy?.mastered && mastery?.mastered;
};

export const getMasteryIcons = (stats: SubjectMetrics | undefined, timeSpent: number) => {
  const isMasteryAchieved = stats?.mastery?.mastered ?? false;
  const isAccuracyAchieved = stats?.accuracy?.mastered ?? false;
  const isTimeSpentAchieved = timeSpent >= (stats?.timeSpent?.target ?? 25);

  return {
    masteryIcon: isMasteryAchieved ? StarBlue : StarGrey,
    accuracyIcon: isAccuracyAchieved ? AccuracyBlue : AccuracyGrey,
    timeSpentIcon: isTimeSpentAchieved ? TimeBlueFilled : TimeGrey,
  };
};

export const getDisplaySubjectLabels = (label: string, showUnlockIcon: boolean) => {
  if (showUnlockIcon) {
    return 'Workshop';
  }

  if (label === 'Computer Science') {
    return 'CS';
  }

  return label;
};
